import React from 'react';

const  IconFilter= () => {

    return (
        <svg width="13px" height="12px" viewBox="0 0 13 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Group Copy</title>
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="filter" transform="translate(-367, -9)" fill="#405363" fillRule="nonzero">
                    <g id="Group-Copy" transform="translate(367, 9.125)">
                        <polygon id="Line" points="13 0.875 13 1.875 2 1.875 2 0.875"></polygon>
                        <polygon id="Line-Copy" points="13 4.875 13 5.875 7 5.875 7 4.875"></polygon>
                        <polygon id="Line-Copy-3" points="6 4.875 6 5.875 0 5.875 0 4.875"></polygon>
                        <polygon id="Line-Copy-2" points="11 8.875 11 9.875 0 9.875 0 8.875"></polygon>
                        <path d="M1.5,0 C2.32842712,0 3,0.671572875 3,1.5 C3,2.32842712 2.32842712,3 1.5,3 C0.671572875,3 0,2.32842712 0,1.5 C0,0.671572875 0.671572875,0 1.5,0 Z M1.5,1 C1.22385763,1 1,1.22385763 1,1.5 C1,1.77614237 1.22385763,2 1.5,2 C1.77614237,2 2,1.77614237 2,1.5 C2,1.22385763 1.77614237,1 1.5,1 Z" id="Oval"></path>
                        <path d="M6.5,4 C7.32842712,4 8,4.67157288 8,5.5 C8,6.32842712 7.32842712,7 6.5,7 C5.67157288,7 5,6.32842712 5,5.5 C5,4.67157288 5.67157288,4 6.5,4 Z M6.5,5 C6.22385763,5 6,5.22385763 6,5.5 C6,5.77614237 6.22385763,6 6.5,6 C6.77614237,6 7,5.77614237 7,5.5 C7,5.22385763 6.77614237,5 6.5,5 Z" id="Oval-Copy"></path>
                        <path d="M11.5,8 C12.3284271,8 13,8.67157288 13,9.5 C13,10.3284271 12.3284271,11 11.5,11 C10.6715729,11 10,10.3284271 10,9.5 C10,8.67157288 10.6715729,8 11.5,8 Z M11.5,9 C11.2238576,9 11,9.22385763 11,9.5 C11,9.77614237 11.2238576,10 11.5,10 C11.7761424,10 12,9.77614237 12,9.5 C12,9.22385763 11.7761424,9 11.5,9 Z" id="Oval-Copy-2"></path>
                    </g>
                </g>
            </g>
        </svg>
    )

}

export default IconFilter;
